'use strict';

export default function f($q, $translate, $ocLazyLoad) {
  'ngInject';

  return {
    load() {
      return $q((resolve) => {
        import('./').then(() => {
          $ocLazyLoad.load({
            name: 'common.bookingForm'
          });
          $translate.refresh().then(() => {
            resolve();
          });
        });
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/common/booking_form/lazy_load_booking_modal.js